import type { EventFactsWeatherDay } from './factsApi';

/**
 * El clima registrado de un evento como un sello corto por día, para que
 * viaje pegado a la línea de tiempo del bloque al que aplica. En °F, que es
 * lo que lee el mercado al que se vende ahora mismo.
 */
export function weatherStamps(days: readonly EventFactsWeatherDay[]): Record<string, string> {
  const out: Record<string, string> = {};
  for (const d of days) {
    const parts: string[] = [];
    if (d.tempMaxC != null) parts.push(`${Math.round((d.tempMaxC * 9) / 5 + 32)}°F`);
    if (d.precipitationMm != null && d.precipitationMm > 0) parts.push(`${(d.precipitationMm / 25.4).toFixed(2)} in`);
    if (parts.length) out[d.day] = parts.join(' · ');
  }
  return out;
}
